import { message } from 'antd'

export const alertMessage = (type, messageShow) => {
    // let s = num + "";
    // while (s.length < size) s = "0" + s;
    // return s;
    if(type == "success"){
        message.success({
            // content: graphQLErrors[0].message,
            content:messageShow,
            key:'1',
            duration: 5,
        })
    }else if(type == "error"){
        message.error({
            // content: graphQLErrors[0].message,
            content:messageShow,
            key:'1',
            duration: 5,
        })
    }else if(type == "warning"){
        message.warning({
            // content: graphQLErrors[0].message,
            content:messageShow,
            key:'1',
            duration: 5,
        })
    }
}
